/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./assets/tailwind.css";
import "primeicons/primeicons.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import routerBrowser from "./router/index";
import * as history from "history";
import { MainLayout } from "./layout/MainLayout";
import { NavigationProvider } from "./context/navigationContext";
import {
  AuthenticatedTemplate,
  MsalProvider,
  useMsalAuthentication,
} from "@azure/msal-react";
import { Provider } from "react-redux";
import axios from "axios";
import { Buffer } from "buffer";

import store from "./store/index";
import { ReloadProvider } from "./context/ReloadProvider";
import { Auth } from "./Auth/auth";
import { LoadingProvider } from "./context/LoadingContext";
import WrapperApp from "./WrapperApp";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest, msalConfig } from "./Auth/b2cService/b2cServiceConfig";

import { PositionUserGPSProvider } from "./context/PositionUserGPS";
import { FilterProvider } from "./context/wrapperContext/queries/FilterContext";

import {
  checkIsCallByPayroll,
  decodificarBase64,
  isBase64,
} from "./utils/utils";
import { ChatbotLoad } from "./utils/homeUtils";
import { locale, addLocale } from "primereact/api";
import { primeReactTranslations } from "./primeReactTranslateOptions";
import Providers from "./context/wrapperContext/index.context";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { generateUrlBase } from "./utils/utils";
import { getLocalAccessToken } from "./Auth/auth/token";

const queryClient = new QueryClient();

function App({ pca }) {
  addLocale("es", primeReactTranslations);

  locale("es");

  const History = history.createBrowserHistory();
  window.Buffer = Buffer;
  const { login, error } = useMsalAuthentication(
    InteractionType.Silent,
    loginRequest
  );
  const getQueryVariable = (variable) => {
    const query = window.location.search.substring(1);
    const vars = query.replace("#state", "&state").split("&");

    if (vars.length > 1) {
      const p2 = vars[1];
      let localStorageToken = p2.split("=");

      localStorage.setItem("accessToken", localStorageToken[1]);
    }
    for (const vrItem of vars) {
      const pair = vrItem.split("=");

      if (pair[0] === variable) {
        return pair[1];
      }
    }
    return "";
  };

  const enrichSessionStateWithCompanyId = async (rawState) => {
    if (rawState?.companyId) {
      return rawState;
    }

    try {
      const tempState = {
        ...rawState,
        userAgent: window.navigator.userAgent.toString(),
      };

      const sessionStateJson = JSON.stringify(tempState);
      const accessToken = getLocalAccessToken();

      const url = generateUrlBase("company-info");

      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          sessionState: sessionStateJson,
        },
      });

      const companyIdFromApi = response?.data?.companyId;

      if (companyIdFromApi) {
        return {
          ...tempState,
          companyId: companyIdFromApi,
        };
      }
      return tempState;
    } catch (error) {
      return {
        ...rawState,
        userAgent: window.navigator.userAgent.toString(),
      };
    }
  };

  useEffect(() => {
    const initializeSession = async () => {
      if (error) {
        login(InteractionType.Redirect, loginRequest);
        window.localStorage.clear();
      } else {
        // get state from master portal, if the state is not present, will do a redirection to master portal.
        const stateQueryVariable = getQueryVariable("state");
        let state = "";

        if (stateQueryVariable !== "") {
          //compare instance id from session storage with instance id from master portal
          const sessionStateStorage = JSON.parse(
            sessionStorage.getItem("sessionState")
          );
          state = JSON.parse(
            Buffer.from(stateQueryVariable, "base64").toString()
          );

          state.userAgent = window.navigator.userAgent.toString();
          const sessionStateJson = state;

          if (sessionStateJson?.instanceId !== sessionStateStorage?.instanceId) {
            //remove session storage
            sessionStorage.removeItem("sessionState");
            window.localStorage.clear();
          }
        }
        if (!sessionStorage.sessionState) {
          // aqui va la funcion
          if (!stateQueryVariable || stateQueryVariable.length === 0) {
            window.location.replace(msalConfig.ctiPortalURI);
          } else {
            let decodedState = JSON.parse(
              Buffer.from(stateQueryVariable, "base64").toString()
            );

            decodedState.userAgent = window.navigator.userAgent.toString();

            // Aquí se completa companyId si no viene en el state
            decodedState = await enrichSessionStateWithCompanyId(decodedState);

            const sessionStateJson = JSON.stringify(decodedState);

            sessionStorage.setItem("sessionState", sessionStateJson);

            axios.defaults.headers.common = {
              ...axios.defaults.headers.common,
              sessionState: sessionStateJson,
            };
          }
        } else {
          const sessionStateStorage = sessionStorage.getItem("sessionState");

          // set as default header the sessionState
          axios.defaults.headers.common = {
            ...axios.defaults.headers.common,
            sessionState: sessionStateStorage,
          };
        }
      };      
    }   

    initializeSession();
  }, [error, login]);

  if (localStorage.getItem("accessToken") === null) {
    localStorage.removeItem("currentTap");
  }

  useEffect(() => {
    const disableBackButton = (event) => {
      event.preventDefault();
      window.history.forward();
    };
    // Agregar el event listener cuando el componente se monta
    window.addEventListener("popstate", disableBackButton);
    // Eliminar el event listener cuando el componente se desmonta
    return () => {
      window.removeEventListener("popstate", disableBackButton);
    };
  }, []);

  return (
    <AuthenticatedTemplate>
      <Provider store={store}>
        <ReloadProvider>
          <Auth>
            <MsalProvider instance={pca}>
              <PositionUserGPSProvider>
                <LoadingProvider>
                  <FilterProvider>
                    <Providers>
                      <WrapperApp>
                        <BrowserRouter history={History}>
                          <NavigationProvider>
                            <QueryClientProvider client={queryClient}>
                              <Routes>
                                <Route exact path="/" element={<MainLayout />}>
                                  {routerBrowser}
                                </Route>
                              </Routes>
                            </QueryClientProvider>
                          </NavigationProvider>
                        </BrowserRouter>
                      </WrapperApp>
                    </Providers>
                  </FilterProvider>
                </LoadingProvider>
              </PositionUserGPSProvider>
            </MsalProvider>
          </Auth>
        </ReloadProvider>
      </Provider>
    </AuthenticatedTemplate>
  );
}

export default App;
